import React, { useEffect, useState } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { Avatar, AvatarImage, AvatarFallback } from '@/components/ui/avatar';

interface StudioInfo {
  studio_name: string;
  logo_url: string | null;
}

export default function StudioBadge({ practitionerId }: { practitionerId: string }) {
  const [studio, setStudio] = useState<StudioInfo | null>(null);

  useEffect(() => {
    const fetch = async () => {
      // Find active membership with show_studio_badge = true
      const { data: membership } = await supabase
        .from('studio_members')
        .select('studio_id, show_studio_badge')
        .eq('practitioner_id', practitionerId)
        .eq('status', 'active')
        .eq('show_studio_badge', true)
        .limit(1)
        .maybeSingle();

      if (!membership) return;

      const { data: studioData } = await supabase
        .from('studios')
        .select('name, logo_url')
        .eq('id', membership.studio_id)
        .single();

      if (studioData) {
        setStudio({
          studio_name: studioData.name,
          logo_url: (studioData as any).logo_url || null,
        });
      }
    };
    fetch();
  }, [practitionerId]);

  if (!studio) return null;

  const logoPublicUrl = studio.logo_url
    ? supabase.storage.from('studio.logo').getPublicUrl(studio.logo_url).data.publicUrl
    : '';

  return (
    <div className="flex items-center gap-1.5 mt-1">
      <Avatar className="h-5 w-5 rounded">
        {logoPublicUrl ? (
          <AvatarImage src={logoPublicUrl} alt={studio.studio_name} className="object-cover" />
        ) : (
          <AvatarFallback className="rounded bg-muted text-[10px]">
            {studio.studio_name.charAt(0)}
          </AvatarFallback>
        )}
      </Avatar>
      <span className="text-xs text-muted-foreground font-medium">{studio.studio_name}</span>
    </div>
  );
}
